export enum HttpStatusCode {
  GONE = 410,
  NO_CONTENT = 204,
  UNAUTHORIZED = 401,
  BAD_GATEWAY = 502,
  TOO_MANY_REQUESTS = 429,
  IM_A_TEAPOT = 418,
  SERVICE_UNAVAILABLE = 503,
}
